/* Quick Quote — five inputs to a real price.
 *
 * Pricing is NOT implemented here. window.BTPricing (assets/bt-pricing.js) is generated
 * verbatim from the customizer by tools/gen-pricing-lib.py, so this page and checkout
 * can't disagree. Garment prices come live from /products/<handle>.js.
 */
(function () {
  'use strict';
  var CFG = window.BT_QQ || {};
  if (!document.getElementById('btqq')) return;

  var $ = function (id) { return document.getElementById(id); };
  var money = function (n) { return '$' + (Math.round((n + Number.EPSILON) * 100) / 100).toFixed(2); };
  var MAX_LOCS = 4;

  var RATES = null;
  var SHIP_SET = new Set();
  var garmentCache = {};      // handle -> { price, title }
  var lastQuote = null;

  // ── funnel tracking (same session key + endpoint as the customizer) ──────────
  var CX = (CFG.cxEventEndpoint || '').trim();
  var SID = (function () {
    try {
      var k = 'bt_cx_sid', v = sessionStorage.getItem(k);
      if (!v) { v = Date.now().toString(36) + Math.random().toString(36).slice(2, 10); sessionStorage.setItem(k, v); }
      return v;
    } catch (e) { return 'nostore-' + Math.random().toString(36).slice(2, 10); }
  })();
  function cx(event, extra) {
    if (!CX) return;
    try {
      var b = { session_id: SID, event: event, referrer: document.referrer || '' };
      for (var k in (extra || {})) if (extra[k] != null && extra[k] !== '') b[k] = extra[k];
      var blob = new Blob([JSON.stringify(b)], { type: 'text/plain;charset=UTF-8' });
      if (navigator.sendBeacon) navigator.sendBeacon(CX, blob);
    } catch (e) { /* analytics must never break the page */ }
  }

  // ── print locations ─────────────────────────────────────────────────────────
  // Driven by pricing-rates.json, so the quote offers exactly the placements the
  // customizer does — including the non-standard ones that carry a surcharge — as
  // add/remove rows rather than a fixed set of checkboxes.
  function locOptions(selected) {
    return ((RATES && RATES.locations) || []).map(function (l) {
      return '<option value="' + l.id + '"' + (l.id === selected ? ' selected' : '') + '>' +
             l.label + (l.standard ? '' : ' — non-standard') + '</option>';
    }).join('');
  }
  function locRow(selected) {
    var method = $('qqMethod').value;
    var side;
    if (method === 'screenprint') {
      // Labelled as a question so it reads as something to fill in, not a default to ignore.
      // Deliberately no default: a pre-filled "1" gets skipped past, and colour count is
      // the single biggest driver of screen-print price.
      side = '<span class="qq-ink"><label>How many colors?</label>' +
             '<input type="number" class="qq-loc-colors" min="1" max="6" placeholder="?" ' +
             'title="Number of ink colors in your artwork at this location"></span>';
    } else if (method === 'embroidery') {
      side = '<span class="qq-ink qq-muted">stitch count estimated</span>';
    } else {
      side = '<span class="qq-ink qq-muted qq-size"></span>';
    }
    return '<div class="qq-loc">' +
             '<select class="qq-loc-place">' + locOptions(selected) + '</select>' + side +
             '<button type="button" class="qq-loc-rm" title="Remove this location" aria-label="Remove location">×</button>' +
           '</div>';
  }
  function currentLocationIds() {
    return Array.prototype.map.call(document.querySelectorAll('.qq-loc-place'), function (s) { return s.value; });
  }
  function buildLocations(keepSelections) {
    var prev = keepSelections ? currentLocationIds() : null;
    var ids = (prev && prev.length) ? prev : ['full_front'];
    $('qqLocList').innerHTML = ids.map(locRow).join('');
    paintDerivedSizes();
    wireLocs();
    syncRowChrome();
  }
  // DTF/DTG size is derived from the placement in the customizer — mirror it so the quote
  // reflects the size actually charged.
  function paintDerivedSizes() {
    var method = $('qqMethod').value;
    var map = (RATES && RATES[method] && RATES[method].locationSizes) || null;
    Array.prototype.forEach.call(document.querySelectorAll('#qqLocList .qq-loc'), function (row) {
      var el = row.querySelector('.qq-size'); if (!el) return;
      var sel = row.querySelector('.qq-loc-place');
      var sz = map && sel && map[sel.value];
      el.textContent = sz ? sz.replace('x', '" × ') + '"' : 'size set by placement';
    });
  }
  function syncRowChrome() {
    var rows = document.querySelectorAll('#qqLocList .qq-loc');
    Array.prototype.forEach.call(rows, function (r) {
      var b = r.querySelector('.qq-loc-rm');
      if (b) b.style.visibility = rows.length > 1 ? 'visible' : 'hidden';
    });
    var add = $('qqAddLoc');
    if (add) {
      add.disabled = rows.length >= MAX_LOCS;
      add.textContent = rows.length >= MAX_LOCS ? 'Up to ' + MAX_LOCS + ' locations' : '+ Add another location';
    }
  }
  function wireLocs() {
    Array.prototype.forEach.call(document.querySelectorAll('.qq-loc-place'), function (el) {
      el.addEventListener('change', function () { paintDerivedSizes(); recalc(); });
    });
    Array.prototype.forEach.call(document.querySelectorAll('.qq-loc-colors'), function (el) {
      el.addEventListener('change', recalc);
      el.addEventListener('input', recalc);
    });
    Array.prototype.forEach.call(document.querySelectorAll('.qq-loc-rm'), function (b) {
      b.addEventListener('click', function () {
        if (document.querySelectorAll('#qqLocList .qq-loc').length <= 1) return;
        var row = b.parentNode;
        row.parentNode.removeChild(row);
        syncRowChrome();
        recalc();
      });
    });
  }

  // ── garment price, live from the storefront ─────────────────────────────────
  function garment(handle) {
    if (garmentCache[handle]) return Promise.resolve(garmentCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (p) {
        var cheapest = (p.variants || []).reduce(function (m, v) {
          return (v.price != null && (m == null || v.price < m)) ? v.price : m;
        }, null);
        var g = { price: (cheapest != null ? cheapest / 100 : null), title: p.title };
        garmentCache[handle] = g;
        return g;
      });
  }

  // ── the quote ───────────────────────────────────────────────────────────────
  function isStandardLoc(id) {
    var l = ((RATES && RATES.locations) || []).filter(function (x) { return x.id === id; })[0];
    return !!(l && l.standard);
  }
  function readLocations() {
    var method = $('qqMethod').value;
    var map = (RATES && RATES[method] && RATES[method].locationSizes) || {};
    var qty = Math.max(1, parseInt($('qqQty').value, 10) || 0);
    var out = [];
    Array.prototype.forEach.call(document.querySelectorAll('#qqLocList .qq-loc'), function (row) {
      var sel = row.querySelector('.qq-loc-place'); if (!sel || !sel.value) return;
      var cEl = row.querySelector('.qq-loc-colors');
      var raw = cEl ? String(cEl.value || '').trim() : '';
      out.push({
        id: sel.value,
        // computePrice reads loc.standard; leaving it undefined made every placement
        // "non-standard" and silently added the 35% surcharge to every quote.
        standard: isStandardLoc(sel.value),
        size: map[sel.value] || '',
        qty: qty,
        colors: cEl ? (parseInt(raw, 10) || 0) : 1,
        needsColors: !!cEl && !raw,
        colorList: '',
        stitches: method === 'embroidery' ? 8000 : 0
      });
    });
    return out;
  }

  function recalc() {
    var out = $('qqOut');
    if (!RATES || !window.BTPricing) { out.innerHTML = '<div class="qq-wait">Loading pricing…</div>'; return; }
    var qty = parseInt($('qqQty').value, 10) || 0;
    var locs = readLocations();
    var method = $('qqMethod').value;

    if (qty < 1) { return say('Enter how many pieces you need.'); }
    if (!locs.length) { return say('Pick at least one print location.'); }
    var moq = (RATES.moq || 12);
    if (qty < moq) {
      return say('<b>Our minimum is ' + moq + ' pieces per design.</b> Enter ' + moq +
                 ' or more to see pricing — or <a href="/pages/contact">ask us about smaller runs</a>.');
    }
    if (locs.some(function (l) { return l.needsColors; })) {
      return say('<b>How many ink colors?</b> Enter the number of colors in your artwork at each ' +
                 'location — it’s the biggest single factor in screen-print pricing.');
    }

    // Decoration cost is independent of the blank (verified), so we quote the print and let
    // the customer pick the garment in the designer.
    var b = window.BTPricing.computePrice(quoteInput(method, qty, locs, 0, null, 'x'));
    if (!b || !(decoOf(b) > 0)) { return say('Couldn’t price that combination — <a href="' +
      CFG.customizerUrl + '">build it in the designer</a> or <a href="/pages/contact">ask us</a>.'); }

    // Per-piece PRINT rate only — the figure the customizer shows on its print line.
    // One-time setup (screens, art prep, vectoring) is called out separately rather than
    // amortised into it, so the two tools reconcile.
    var perPrint = runOf(b) / qty;
    var setupTotal = setupOf(b);
    lastQuote = { method: method, qty: qty, locs: locs, perPrint: perPrint,
                  printTotal: decoOf(b), setup: setupTotal };

    out.innerHTML =
      '<div class="qq-price">' +
        '<div class="qq-cell qq-tot"><span>' + money(perPrint) + '</span><em>per piece, print</em></div>' +
        '<div class="qq-cell qq-per"><span>' + money(decoOf(b)) + '</span><em>decoration, ' + qty + ' pcs</em></div>' +
      '</div>' +
      (setupTotal > 0
        ? '<div class="qq-setup">Includes <b>' + money(setupTotal) + '</b> one-time setup' +
          (b.setupFees ? ' — ' + money(b.setupFees) + ' screens' : '') +
          (b.artPrep ? ', ' + money(b.artPrep) + ' art prep' : '') + '. Reorders skip it.</div>'
        : '') +
      '<div class="qq-meta">' + qty + ' pcs · ' + methodLabel(method) + ' · ' +
        locs.length + ' location' + (locs.length > 1 ? 's' : '') +
        (method === 'screenprint' ? ' · ' + locs.map(function (l) { return l.colors + 'c'; }).join(' + ') : '') +
        ' · garment not included</div>';

    // Garment colour only moves the price on DTG. Screen print applies an underbase on
    // EVERY job regardless of shade, and DTF/embroidery don't care — so "dark garments
    // need an underbase (one extra color)" was untrue for three of the four methods and
    // implied a surcharge that doesn't exist. Verified against the engine: light and dark
    // are identical for screenprint/dtf/embroidery, and differ only for dtg.
    $('qqFine').textContent = 'Decoration only, for standard sizes (S–XL). ' +
      (method === 'dtg' ? 'Priced on a dark garment; light garments cost less. ' : '') +
      'Extended sizes (2XL+) and rush turnaround cost more. ' +
      'Priced by the same engine that charges your order at checkout.';
    // The href is rendered server-side so the CTA works with no JS and before any quote
    // exists; this only re-asserts it (and is where a deep link would be appended).
    $('qqDesign').setAttribute('href', CFG.customizerUrl);

    renderCheapest(method, qty, locs, perPrint);
    renderTierTable(method, locs, qty);
    renderBreakNudge(method, qty, locs, perPrint);

    cx('quote_calculated', {
      method: method, pieces: qty, total: Math.round(decoOf(b) * 100) / 100,
      meta: { perPrint: Math.round(perPrint * 100) / 100,
              locations: locs.map(function (l) { return l.id + ':' + l.colors; }) }
    });
  }


  // The price breaks are whatever pricing-rates.json says they are — hardcoding them is how
  // the tips ended up telling people to check 48 and 144, which sit just UNDER the real
  // breaks at 50 and 150. Always derive.
  function breakPoints(method) {
    var cfg = RATES[method] || {};
    var moq = RATES.moq || 12;
    return (cfg.qtyTiers || []).map(function (t) { return t.min; })
                               .filter(function (m) { return m >= moq; });
  }
  // Concrete, per-order version of the same advice.
  function renderBreakNudge(method, qty, locs, perPrint) {
    var el = $('qqNudge'); if (!el) return;
    var next = breakPoints(method).filter(function (m) { return m > qty; })[0];
    if (!next) { el.innerHTML = ''; return; }
    var atNext = locs.map(function (l) { var c = {}; for (var k in l) c[k] = l[k]; c.qty = next; return c; });
    var b = window.BTPricing.computePrice(quoteInput(method, next, atNext, 0, null, 'x'));
    var nextPer = runOf(b) / next;
    if (!(nextPer < perPrint)) { el.innerHTML = ''; return; }
    var need = next - qty;
    el.innerHTML = '<b>' + need + ' more piece' + (need === 1 ? '' : 's') + ' and you hit the ' + next +
      ' break</b> — ' + money(nextPer) + '/pc instead of ' + money(perPrint) +
      ', saving ' + money((perPrint - nextPer) * next) + ' on ' + next + ' pieces.';
  }

  function say(html) { $('qqOut').innerHTML = '<div class="qq-wait">' + html + '</div>'; $('qqCheap').innerHTML = ''; var n = $('qqNudge'); if (n) n.innerHTML = ''; }
  // runOf = the per-run print cost (what the customizer shows per piece).
  // setupOf = one-time fees. decoOf = both, i.e. everything decoration-related.
  function runOf(b) {
    return (b.printBase || 0) + (b.placement || 0) + (b.inkUp || 0) +
           (b.embellish || 0) + (b.colorChange || 0);
  }
  function setupOf(b) { return (b.setupFees || 0) + (b.artPrep || 0) + (b.digitizing || 0); }
  function decoOf(b) { return runOf(b) + setupOf(b); }
  function quoteInput(method, qty, locs, garmentSubtotal, tier, handle) {
    return {
      method: method, totalPieces: qty, locations: locs,
      colorSizes: [{ color: 'Black', sizes: { M: qty } }],
      shade: 'dark', shadeOverride: false,
      garmentSubtotal: garmentSubtotal, shipTier: tier, discountTier: 'normal', premium: false,
      productHandle: handle, title: handle, garmentType: 'tee', vectorFiles: 1,
      extras: { vectoring: method === 'screenprint', transparentBg: false, polyBag: false,
                tagRemoval: false, sizeStickers: false, hangTags: false, splitShip: false,
                splitShipLocations: 1, colorChange: false, colorChangeInks: 1 }
    };
  }

  // "As cheap as" — the cheapest blank in each category, priced all-in, so nobody is
  // surprised at checkout by a garment cost the decoration price didn't include.
  function renderCheapest(method, qty, locs, perPrint) {
    var el = $('qqCheap');
    Promise.all(CFG.catalog.map(function (cat) {
      return Promise.all(cat.items.map(function (it) {
        return garment(it.handle).then(function (g) { return { handle: it.handle, g: g }; })
                                 .catch(function () { return null; });
      })).then(function (rows) {
        var ok = rows.filter(function (r) { return r && r.g && r.g.price != null; })
                     .sort(function (a, b) { return a.g.price - b.g.price; });
        return ok.length ? { cat: cat, pick: ok[0] } : null;
      });
    })).then(function (list) {
      var rows = list.filter(Boolean).map(function (x) {
        var b = window.BTPricing.computePrice(
          quoteInput(method, qty, locs, x.pick.g.price * qty, null, x.pick.handle));
        var per = b.total / qty;
        return '<li><span class="qq-cheap-cat">' + x.cat.label + '</span>' +
               '<span class="qq-cheap-price">' + money(per) + '<em>/pc all-in</em></span>' +
               '<span class="qq-cheap-name">using the ' + x.pick.g.title + '</span></li>';
      }).join('');
      el.innerHTML = rows
        ? '<p class="qq-cheap-lead">As cheap as:</p><ul class="qq-cheap-list">' + rows + '</ul>'
        : '';
    }).catch(function () { el.innerHTML = ''; });
  }

  // A published tier table, so the whole price curve is visible without touching the form.
  function renderTierTable(method, locs, currentQty) {
    var wrap = $('qqTableWrap');
    var cfg = RATES[method]; if (!cfg || !cfg.qtyTiers) { wrap.innerHTML = ''; return; }
    var moq = RATES.moq || 12;
    var qtys = cfg.qtyTiers.map(function (t) { return Math.max(t.min, moq); })
                           .filter(function (q, i, a) { return a.indexOf(q) === i; });
    var oneLoc = [{ id: 'full_front', standard: isStandardLoc('full_front'),
                    size: (cfg.locationSizes && cfg.locationSizes.full_front) || '',
                    qty: 0, colors: 1, colorList: '', stitches: method === 'embroidery' ? 8000 : 0 }];
    // Mark the tier the customer's quantity actually falls in, so the table connects to
    // what they typed instead of being an abstract price list.
    var inTier = null;
    qtys.forEach(function (q) { if (currentQty != null && currentQty >= q) inTier = q; });
    var cells = qtys.map(function (q) {
      var l = [Object.assign({}, oneLoc[0], { qty: q })];
      var b = window.BTPricing.computePrice(quoteInput(method, q, l, 0, null, 'x'));
      return { q: q, per: runOf(b) / q, cur: q === inTier };
    });
    wrap.innerHTML =
      '<h2 class="qq-table-h">' + methodLabel(method).replace(/^./, function (c) { return c.toUpperCase(); }) +
        ' pricing at a glance</h2>' +
      '<p class="qq-table-sub">One ' + (method === 'embroidery' ? 'logo' : 'color') +
        ', front only, decoration per piece. More pieces or fewer colors bring it down.</p>' +
      '<div class="qq-table-scroll"><table class="qq-table"><thead><tr><th>Qty</th>' +
        cells.map(function (c) { return '<th' + (c.cur ? ' class="is-current"' : '') + '>' + c.q + '</th>'; }).join('') +
      '</tr></thead><tbody><tr><th>Per piece</th>' +
        cells.map(function (c) { return '<td' + (c.cur ? ' class="is-current"' : '') + '>' + money(c.per) + '</td>'; }).join('') +
      '</tr></tbody></table></div>';
  }

  function methodLabel(m) {
    return { screenprint: 'screen print', dtf: 'DTF transfer', dtg: 'DTG', embroidery: 'embroidery' }[m] || m;
  }

  // ── email me this quote ─────────────────────────────────────────────────────
  function wireEmail() {
    $('qqEmail').addEventListener('click', function () {
      var w = $('qqEmailWrap');
      w.hidden = !w.hidden;
      if (!w.hidden) { $('qqEmailAddr').focus(); cx('quote_email_opened', {}); }
    });
    $('qqEmailSend').addEventListener('click', function () {
      var addr = ($('qqEmailAddr').value || '').trim();
      var msg = $('qqEmailMsg');
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(addr)) { msg.textContent = 'Please enter a valid email address.'; return; }
      if (!lastQuote) { msg.textContent = 'Set your options above first.'; return; }
      msg.textContent = 'Sending…';
      fetch(CFG.quoteEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },   // simple request — no CORS preflight
        body: JSON.stringify({
          email: addr, zip: '',
          product: methodLabel(lastQuote.method) + ' — garment not included',
          handle: '', method: lastQuote.method, pieces: lastQuote.qty,
          locations: lastQuote.locs.map(function (l) {
            return l.id + (l.colors > 1 ? ' (' + l.colors + ' colors)' : '');
          }).join(', '),
          total: Math.round(lastQuote.printTotal * 100) / 100,
          perPiece: Math.round(lastQuote.perPrint * 100) / 100,
          session_id: SID
        })
      }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        msg.textContent = '✓ Sent — check your inbox. We’ll follow up if you have questions.';
        cx('quote_emailed', { email: addr, method: lastQuote.method,
                              pieces: lastQuote.qty, total: Math.round(lastQuote.printTotal * 100) / 100 });
      }).catch(function () {
        msg.textContent = 'Couldn’t send just now — please email customerservice@bulkthreads.com.';
      });
    });
    $('qqDesign').addEventListener('click', function () {
      if (lastQuote) cx('quote_design_click', {
        method: lastQuote.method, pieces: lastQuote.qty,
        total: Math.round(lastQuote.printTotal * 100) / 100
      });
    });
  }

  // ── boot ────────────────────────────────────────────────────────────────────
  ['qqQty'].forEach(function (id) {
    $(id).addEventListener('change', recalc);
    $(id).addEventListener('input', recalc);
  });
  $('qqMethod').addEventListener('change', function () { buildLocations(true); recalc(); });
  $('qqAddLoc').addEventListener('click', function () {
    var list = $('qqLocList');
    if (list.querySelectorAll('.qq-loc').length >= MAX_LOCS) return;
    var used = currentLocationIds();
    var next = ((RATES && RATES.locations) || []).filter(function (l) { return used.indexOf(l.id) < 0; })[0];
    list.insertAdjacentHTML('beforeend', locRow(next ? next.id : 'full_back'));
    paintDerivedSizes(); wireLocs(); syncRowChrome(); recalc();
  });
  wireEmail();
  cx('quote_page_view', {});

  // Shipping is free EXCEPT a per-piece upcharge on bulky items, which computePrice decides
  // via shipUpchargeOf(handle) -> SHIP_SET. Loading it empty would silently under-quote every
  // hoodie, so pull the same garment-shipping.json the customizer uses.
  Promise.all([
    fetch(CFG.ratesUrl).then(function (r) { return r.json(); }),
    fetch(CFG.shippingUrl).then(function (r) { return r.json(); }).catch(function () { return { upcharge: [] }; })
  ]).then(function (res) {
    RATES = res[0];
    SHIP_SET = new Set((res[1] && res[1].upcharge) || []);
    var wait = function () {
      if (!window.BTPricing) return setTimeout(wait, 50);
      window.BTPricing.configure({ PRICE_RATES: RATES, DISCOUNTS: null, SHIP_SET: SHIP_SET });
      buildLocations();          // locations need RATES, so this is the first real build
      recalc();
    };
    wait();
  }).catch(function (e) {
    $('qqOut').innerHTML = '<div class="qq-wait">Pricing is unavailable right now — ' +
      '<a href="' + CFG.customizerUrl + '">use the designer</a> or <a href="/pages/contact">contact us</a>.</div>';
    console.warn('[quick-quote] rates failed', e && e.message);
  });
})();
